import PropTypes from 'prop-types';
import { CustomsPropType } from './customs';
import { ShippingOptionsPropType } from './shipping-options';
import { PackagePropType } from './package';
import { AddressPropType } from './address';
import { InsuranceProviderPropType } from './insurance-provider';

export const ShipmentConfigurationPropType = PropTypes.shape({
  sellerLabelProviderId: PropTypes.string,
  serviceId: PropTypes.string,
  shipFromId: PropTypes.string,
  shipTo: AddressPropType,
  shipDate: PropTypes.string,
  packages: PropTypes.arrayOf(PackagePropType),
  packageSetId: PropTypes.string,
  options: ShippingOptionsPropType,
  insuranceProvider: InsuranceProviderPropType,
  customs: CustomsPropType,
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.number),
});

/**
 * @typedef {object} ShipmentConfigurationPropType
 * @property {string} sellerLabelProviderId
 * @property {string} serviceId
 * @property {string} shipFromId
 * @property {AddressPropType} shipTo
 * @property {string} shipDate
 * @property {PackagePropType[]} packages
 * @property {string} packageSetId
 * @property {ShippingOptionsPropType} options
 * @property {InsuranceProviderPropType} insuranceProvider
 * @property {CustomsPropType} customs
 * @property {number[]} fulfillmentPlanIds
 */
